//eslint-disable-next-line
//@ts-nocheck

import { LineStudyPlotStyle } from "@/lib/datafeed/utils.ts";
import {
  CustomIndicator,
  PineJS,
  RawStudyMetaInfoId,
} from "@tradingView/charting_library";

import {
  FilledAreaType,
  StudyInputType,
  StudyPlotType,
} from "@/lib/datafeed/tvTypes.ts";

import {
  GetPriceSeries,
  MovingAverage,
  AccessCheck,
  GetAsymmetricVolatility,
} from "@/lib/indicators/indicators-common-functions";

import { IIndicatorOptions } from "@/domain/interfaces/general.interface";

export const rollingVwap = (
  PineJS: PineJS,
  options?: IIndicatorOptions,
): CustomIndicator => {
  return {
    name: "Rolling VWAP",
    metainfo: {
      _metainfoVersion: 51,
      id: "rolling-vwap@tv-basicstudies-1" as RawStudyMetaInfoId,
      description: "[SFT] Rolling VWAP",
      shortDescription: "[SF] VWAP",
      is_hidden_study: false,
      is_price_study: true,
      isCustomIndicator: true,
      format: {
        type: "price",
        precision: 2,
      },
      plots: [
        { id: "fastVwapPlot", type: StudyPlotType.Line },
        { id: "fastPlus1SigmaPlot", type: StudyPlotType.Line },
        { id: "fastMinus1SigmaPlot", type: StudyPlotType.Line },
        { id: "fastPlus2SigmaPlot", type: StudyPlotType.Line },
        { id: "fastMinus2SigmaPlot", type: StudyPlotType.Line },
        { id: "fastPlus3SigmaPlot", type: StudyPlotType.Line },
        { id: "fastMinus3SigmaPlot", type: StudyPlotType.Line },
        { id: "slowVwapPlot", type: StudyPlotType.Line },
        { id: "slowPlus1SigmaPlot", type: StudyPlotType.Line },
        { id: "slowMinus1SigmaPlot", type: StudyPlotType.Line },
        { id: "slowPlus2SigmaPlot", type: StudyPlotType.Line },
        { id: "slowMinus2SigmaPlot", type: StudyPlotType.Line },
        { id: "slowPlus3SigmaPlot", type: StudyPlotType.Line },
        { id: "slowMinus3SigmaPlot", type: StudyPlotType.Line },
      ],
      filledAreas: [
        {
          id: "fastBackground",
          objAId: "fastPlus3SigmaPlot",
          objBId: "fastMinus3SigmaPlot",
          title: "Background",
          type: FilledAreaType.TypePlots,
        },
        {
          id: "slowBackground",
          objAId: "slowPlus3SigmaPlot",
          objBId: "slowMinus3SigmaPlot",
          title: "Background",
          type: FilledAreaType.TypePlots,
        },
      ],
      defaults: {
        filledAreasStyle: {
          fastBackground: {
            color: "rgba(255, 160, 40, 0.1)",
            transparency: 10,
            visible: false,
          },
          slowBackground: {
            color: "rgba(13, 157, 219, 0.1)",
            transparency: 10,
            visible: false,
          },
        },
        styles: {
          fastVwapPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgb(255, 160, 40)",
            transparency: 40,
          },
          fastPlus1SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(255, 160, 40, 0.5)",
          },
          fastMinus1SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(255, 160, 40, 0.5)",
          },
          fastPlus2SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(255, 160, 40, 0.5)",
          },
          fastMinus2SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(255, 160, 40, 0.5)",
          },
          fastPlus3SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(255, 160, 40, 0.5)",
          },
          fastMinus3SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(255, 160, 40, 0.5)",
          },
          slowVwapPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgb(13, 157, 219)",
            transparency: 40,
          },
          slowPlus1SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(13, 157, 219, 0.5)",
          },
          slowMinus1SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(13, 157, 219, 0.5)",
          },
          slowPlus2SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(13, 157, 219, 0.5)",
          },
          slowMinus2SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(13, 157, 219, 0.5)",
          },
          slowPlus3SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(13, 157, 219, 0.5)",
          },
          slowMinus3SigmaPlot: {
            linestyle: 0,
            visible: true,
            linewidth: 1,
            plottype: LineStudyPlotStyle.Line,
            trackPrice: false,
            color: "rgba(13, 157, 219, 0.5)",
          },
        },
        precision: 2,
        inputs: {},
      },
      styles: {
        fastVwapPlot: {
          title: "Fast VWAP",
          histogramBase: 0,
        },
        fastPlus1SigmaPlot: {
          title: "Fast VWAP +1 Sigma",
          histogramBase: 0,
        },
        fastMinus1SigmaPlot: {
          title: "Fast VWAP -1 Sigma",
          histogramBase: 0,
        },
        fastPlus2SigmaPlot: {
          title: "Fast VWAP +2 Sigma",
          histogramBase: 0,
        },
        fastMinus2SigmaPlot: {
          title: "Fast VWAP -2 Sigma",
          histogramBase: 0,
        },
        fastPlus3SigmaPlot: {
          title: "Fast VWAP +3 Sigma",
          histogramBase: 0,
        },
        fastMinus3SigmaPlot: {
          title: "Fast VWAP -3 Sigma",
          histogramBase: 0,
        },
        slowVwapPlot: {
          title: "Slow VWAP",
          histogramBase: 0,
        },
        slowPlus1SigmaPlot: {
          title: "Slow VWAP +1 Sigma",
          histogramBase: 0,
        },
        slowMinus1SigmaPlot: {
          title: "Slow VWAP -1 Sigma",
          histogramBase: 0,
        },
        slowPlus2SigmaPlot: {
          title: "Slow VWAP +2 Sigma",
          histogramBase: 0,
        },
        slowMinus2SigmaPlot: {
          title: "Slow VWAP -2 Sigma",
          histogramBase: 0,
        },
        slowPlus3SigmaPlot: {
          title: "Slow VWAP +3 Sigma",
          histogramBase: 0,
        },
        slowMinus3SigmaPlot: {
          title: "Slow VWAP -3 Sigma",
          histogramBase: 0,
        },
      },
      inputs: [],
    },

    constructor: function () {
      this.init = function (context, inputCallback) {
        this._context = context;
        this._input = inputCallback;
      };

      this.main = function (context, inputCallback) {
        this._context = context;
        this._input = inputCallback;

        // Market data parsing
        const closeSeries: any = context.new_var(
          PineJS.Std.close(this._context),
        );

        // Calculations
        const MINUTES_IN_DAY: number = 1440;
        const period: string = PineJS.Std.period(this._context);
        let fastWindow: number = MINUTES_IN_DAY / Number(period);
        let slowWindow: number = 7 * fastWindow;

        if (period == "1D") {
          fastWindow = 28;
          slowWindow = 84;
        }

        const fastVwap: number = PineJS.Std.vwma(
          closeSeries,
          fastWindow,
          this._context,
        );
        const fastSigma: number = PineJS.Std.stdev(
          closeSeries,
          fastWindow,
          this._context,
        );

        const slowVwap: number = PineJS.Std.vwma(
          closeSeries,
          slowWindow,
          this._context,
        );
        const slowSigma: number = PineJS.Std.stdev(
          closeSeries,
          slowWindow,
          this._context,
        );

        const fastPlus1Sigma: number = fastVwap + fastSigma;
        const fastMinus1Sigma: number = fastVwap - fastSigma;

        const fastPlus2Sigma: number = fastVwap + 2 * fastSigma;
        const fastMinus2Sigma: number = fastVwap - 2 * fastSigma;

        const fastPlus3Sigma: number = fastVwap + 3 * fastSigma;
        const fastMinus3Sigma: number = fastVwap - 3 * fastSigma;

        const slowPlus1Sigma: number = slowVwap + slowSigma;
        const slowMinus1Sigma: number = slowVwap - slowSigma;

        const slowPlus2Sigma: number = slowVwap + 2 * slowSigma;
        const slowMinus2Sigma: number = slowVwap - 2 * slowSigma;

        const slowPlus3Sigma: number = slowVwap + 3 * slowSigma;
        const slowMinus3Sigma: number = slowVwap - 3 * slowSigma;

        const shouldShowData: boolean = AccessCheck(
          PineJS,
          this._context,
          options,
        );

        if (shouldShowData) {
          return [
            fastVwap,
            fastPlus1Sigma,
            fastMinus1Sigma,
            fastPlus2Sigma,
            fastMinus2Sigma,
            fastPlus3Sigma,
            fastMinus3Sigma,
            slowVwap,
            slowPlus1Sigma,
            slowMinus1Sigma,
            slowPlus2Sigma,
            slowMinus2Sigma,
            slowPlus3Sigma,
            slowMinus3Sigma,
          ];
        } else {
          return [
            NaN,
            NaN,
            NaN,
            NaN,
            NaN,
            NaN,
            NaN,
            NaN,
            NaN,
            NaN,
            NaN,
            NaN,
            NaN,
            NaN,
          ];
        }
      };
    },
  };
};
